import { handleApiErrors } from '../../../../../../core/data-access/http-client/interceptors/error.interceptor';
import { AllInputTypes, FormInputConfig } from '../../../../../../../trash/shared/interfaces/form-input-config';
import { FormComponent } from '../../../../../../../trash/shared/components/dynamic-form/form/form.component';
import { ErrorOrError } from '../../../../../../core/results/error-or/models/error-or-error.model';
import { Subscription, tap, catchError, finalize, Subject, debounceTime } from 'rxjs';
import { AccountUserService } from '../../../services/account-user.service';
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ChangeDetectorRef, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

import { IRevokeSpecializedRolesToAccountUserRequest } from '../../dtos/requests/revoke-roles-to-account-user.request';
import { IAssignSpecializedRolesToAccountUserRequest } from '../../dtos/requests/assign-roles-to-account-user.request';
import { SpecializedRolesService } from '../../../../specialized-roles/services/specialized-roles.service';
import { getIdFormConfig } from '../../../../../../../views/pages/adminstration/temp-common/utils';
import { Logger } from '../../../../../../core/utilities/logging/logger';
import { ToastService } from '../../../../../../../trash/shared/components/toasters/Toast.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-assign-revoke-specialized-roles',
    standalone: true,
    imports: [ReactiveFormsModule, CommonModule, DialogModule, ButtonModule, FormsModule, FormComponent, TranslateModule],
    templateUrl: './assign-revoke-specialized-roles.component.html',
    styleUrl: './assign-revoke-specialized-roles.component.scss'
})
export class AssignRevokeSpecializedRolesComponent {
    private subscriptions: Subscription[] = [];

    isLoadingActionItem = false;
    form: FormInputConfig[] = [];
    formValues: any = null;
    accountUserId: string | undefined;
    validationErrors: any = {};
    validationEmit = false;
    specializedRoles: any = [];
    selectedSpecializedRoleItem: any = [];
    private searchSubject = new Subject<any>();

    constructor(
        private _SpecializedRolesService: SpecializedRolesService,
        private _accountUserService: AccountUserService,
        public dataObj: DynamicDialogConfig,
        private toastService: ToastService,
        private cdr: ChangeDetectorRef,
        private ref: DynamicDialogRef,
        private translate: TranslateService
    ) {}

    ngOnInit(): void {
        this.accountUserId = this.dataObj?.data?.item?.id;
        if (this.accountUserId) {
            this.formValues = this.dataObj?.data?.item;
        }
        if (this.dataObj?.data?.type == 'revoke') {
            this.selectedSpecializedRoleItem = this.dataObj?.data?.item?.specializedRoles;
            this.processRolesResponse({
                items: this.dataObj?.data?.item?.specializedRoles
            });
        } else {
            this.getAllSpecializedRoles();
        }
        this.initForm();

        this.searchSubject.pipe(debounceTime(1000)).subscribe((field: any) => {
            if (field.keyword.length >= 2 || field.keyword.length == 0) {
                if (field?.fieldName == 'specializedRoles') {
                    this.getAllSpecializedRoles(field?.keyword);
                    this.selectedSpecializedRoleItem = this.selectedSpecializedRoleItem.filter(
                        (value: any, index: any, self: any) => index === self.findIndex((t: any) => t.value === value.value)
                    );
                }
            }
        });
    }

    onFilterSelect(e: any) {
        this.searchSubject.next(e);
    }

    // Initialize the form
    initForm() {
        this.form = [
            getIdFormConfig(this.dataObj?.data?.item?.id),
            {
                type: AllInputTypes.MultiSelect,
                name: 'specializedRoles',
                label: this.translate.instant('USER_MANAGEMENT.SPECIALIZED_ROLES'),
                placeholder: this.translate.instant('GENERAL.SELECT'),
                widthClass: 'col-12',
                listValues: this.specializedRoles,
                defaultValue: null,
                validation: [
                    {
                        function: Validators.required,
                        errorMessage: `${this.translate.instant('GENERAL.PLEASE_SELECT')} ${this.translate.instant('USER_MANAGEMENT.SPECIALIZED_ROLES')}`
                    }
                ]
            }
        ];
    }
    valueChanged(data: any) {
        this.formValues = { ...data };
    }

    onClose(data?: any) {
        this.ref.close(data);
    }
    emitValidation() {
        this.validationEmit = !this.validationEmit;
        this.cdr.detectChanges();
    }

    async getAllSpecializedRoles(keyword: string = '') {
        let specializedRolesSubscription: Subscription = (await this._SpecializedRolesService.getAll({ SearchKeyword: keyword }))
            .pipe(
                tap((res: any) => this.processRolesResponse(res)),
                catchError((errors: ErrorOrError[]) => handleApiErrors(errors, this.toastService)),
                finalize(() => {})
            )
            .subscribe();

        this.subscriptions.push(specializedRolesSubscription);
    }
    private processRolesResponse(response: any): void {
        if (response) {
            let items: any = response?.items;
            this.specializedRoles = items?.map((item: any) => {
                return {
                    label: item.englishName,
                    value: item.id
                };
            });

            if (this.dataObj?.data?.type !== 'revoke') {
                // Check if this.dataObj?.data?.item?.specializedRoles exists and has items
                if (this.dataObj?.data?.item?.specializedRoles?.length > 0) {
                    const existingRoleValues = this.dataObj?.data?.item?.specializedRoles?.map((role: any) => role.id);

                    // Remove items from this.specializedRoles that already exist in this.dataObj?.data?.item?.specializedRoles
                    this.specializedRoles = this.specializedRoles.filter((role: any) => !existingRoleValues.includes(role.value));

                    // if (this.specializedRoles?.length <= 0) {
                    //   this.onClose();
                    // }
                }
            }
            // Check if form[1] is initialized before using it
            if (this.form[1]) {
                const newItems = this.selectedSpecializedRoleItem.filter(
                    (el2: any) => !this.specializedRoles.find((el1: any) => el1.value === el2.value)
                );
                this.specializedRoles.push(...newItems);
                this.form[1].listValues = this.specializedRoles; // Safe to access listValues
            } else {
            }

            this.cdr.markForCheck();
        }
    }

    async submitForm(data: any) {
        this.isLoadingActionItem = true;
        if (this.dataObj?.data?.type == 'revoke') {
            const revokeData: IRevokeSpecializedRolesToAccountUserRequest = this.prepareRevokeDataRequest(data);
            const subscription = (await this._accountUserService.RevokeSpecializedRolesToAccountUser(revokeData, this.formValues.id))
                .pipe(
                    tap((res: any) => {
                        this.processAssignRevokeResponse(res);
                    }),
                    catchError((errors: ErrorOrError[]) => handleApiErrors(errors, this.toastService)),
                    finalize(() => {
                        this.isLoadingActionItem = false;
                        this.cdr.detectChanges();
                    })
                )
                .subscribe();
            this.subscriptions.push(subscription);
        } else {
            const AssignData: IAssignSpecializedRolesToAccountUserRequest = this.prepareAssignDataRequest(data);
            const subscription = (await this._accountUserService.AssignSpecializedRolesToAccountUser(AssignData, this.formValues.id))
                .pipe(
                    tap((res: any) => {
                        this.processAssignRevokeResponse(res);
                    }),
                    catchError((errors: ErrorOrError[]) => handleApiErrors(errors, this.toastService)),
                    finalize(() => {
                        this.isLoadingActionItem = false;
                        this.cdr.detectChanges();
                    })
                )
                .subscribe();
            this.subscriptions.push(subscription);
        }
    }
    private prepareAssignDataRequest(data: any): IAssignSpecializedRolesToAccountUserRequest {
        return {
            ids: data?.specializedRoles
        };
    }

    private prepareRevokeDataRequest(data: any): IRevokeSpecializedRolesToAccountUserRequest {
        return {
            ids: data?.specializedRoles
        };
    }
    private processAssignRevokeResponse(response: any) {
        if (this.dataObj?.data?.type == 'revoke') {
            this.toastService.showSuccess('Success', 'Revoking was is successfully');
        } else {
            this.toastService.showSuccess('Success', 'Assigning Roles was successfully');
        }
        this.onClose(true);
        this.cdr.detectChanges();
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}
